<template>
  <div v-if="detailsData.data">
    <div
      v-if="
        (detailsData.data && detailsData.data.userType == 0) ||
        detailsData.data.userType == 2
      "
      class="Publisher"
    >
      <div class="title">发布者</div>
      <div @click="goBkOrBj" class="logo">
        <img
          v-if="autherInfo.headImg"
          v-lazy="`${$global.imgUrl}${autherInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/xuezhe.png" alt="" />
        <span>{{ autherInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div v-if="autherInfo.foundedDate" class="listItem">
          <div class="time">{{ autherInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ timeData.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div class="listItem">
          <div class="time">{{ timeData.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div v-if="timeData.letterCount" class="listItem">
          <div class="time">{{ timeData.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div
      v-if="detailsData.data && detailsData.data.userType == 1"
      class="Publisher"
    >
      <div class="title">期刊</div>
      <div @click="goBk" class="logo">
        <!-- periodicalLogo   v-if="periodicalInfo.headImg"-->

        <img
          v-if="periodicalInfo.headImg"
          v-lazy="`${$global.imgUrl}${periodicalInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ periodicalInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div class="time">{{ periodicalInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ periodiID.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <!-- <div class="wenxian">
      <div class="title">相似文献</div>
      <ul class="ulList">
        <li
          @click="detailsClick(item)"
          :class="i + 1 === wenxian.length ? '' : 'msg'"
          v-for="(item, i) in wenxian"
          :key="item.articleId"
          style="cursor: pointer"
          v-html="item.title"
        ></li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "right",
  props: [
    "wenxian",
    "detailsData",
    "autherInfo",
    "periodiID",
    "periodicalInfo",
  ],
  data() {
    return {
      headImg: "",
      authorImg: sessionStorage.getItem("authorImg"),
      periodImg: sessionStorage.getItem("periodImg"),
      timeData: {},
    };
  },
  watch: {
    detailsData() {
      this.getPublisherInfo();
    },
  },
  computed: {
    ...mapState(["hasLogin"]),
  },
  methods: {
    detailsClick(e) {
      console.log(e);
      let routerUrl = "";
      if (e.articleType === 0 && e.type === 0) {
        routerUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 0 && e.type === 3) {
        routerUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 6) {
        routerUrl = this.$router.resolve({
          path: "/dataDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 5) {
        routerUrl = this.$router.resolve({
          path: "/msgDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 2) {
        routerUrl = this.$router.resolve({
          path: "/concentrationDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      }
      console.log(routerUrl);
      window.open(routerUrl.href, "_blank");
    },
    async getPublisherInfo() {
      let PublisherObj = {
        createUser: this.detailsData.data.createUser,
      };
      this.detailsData.data.companyId
        ? (PublisherObj["companyId"] = this.detailsData.data.companyId)
        : null;
      console.log(PublisherObj, "PublisherObj");
      const timeData = await this.$apis.recomendServe.PublisherInfo(
        PublisherObj
      );
      console.log(timeData, "timeData");
      this.timeData = timeData.data;
    }, 


    goBkOrBj() {
      if (this.detailsData.data.userType === 2) {
        let routeUrl = this.$router.resolve({
          path: `/jghdetail`,
          query: {
            title: "机构号",
            id: this.detailsData.data.companyId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/${
            this.detailsData.data.userType === 1 ? "bkzxdetail" : "bjzxdetail"
          }`,
          query: {
            title:
              this.detailsData.data.userType === 1 ? "百科在线" : "百家在线",
            id:
              this.detailsData.data.userType === 1
                ? this.detailsData.data.companyId
                : this.detailsData.data.createUser,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    goBk() {
      // console.log(this.periodicalInfo.id);
      this.$router.push(
        `/bkzxdetail?title=百科在线&id=${this.detailsData.data.companyId}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 270px;
  //height: 250px;
  //padding-left: 25px;
  padding-top: 20px;
  padding-bottom: 40px;
  background: #ffffff;
  margin-left: 10px;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
    border: 1px solid #A3CBE7;
  border-radius: 10px;
  //.xian{
  //  width: 270px;
  //  height: 1px;
  //  top: 60px;
  //  border: 1px solid #E5E5E5;
  //  background: pink;
  //  right: 0px;
  //}
  .ulList {
    padding-left: 25px;
    padding-right: 25px;

    li {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      //line-height: 24px;
      border-bottom: 1px dashed #e8e8e8;
      //border-style: dashed;
    }
  }

  .title {
    font-size: 18px;

    font-weight: bold;
    height: 20px;
    line-height: 20px;
    color: #333333;
    width: 270px;
    padding-left: 25px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5e5;
    //border-bottom: 1px solid #000;
  }
}

.Publisher {
  width: 270px;
  padding: 20px 0 10px 25px;
  background: #ffffff;
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
    border: 1px solid #A3CBE7;
  border-radius: 10px;
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
  }

  .logo {
    display: flex;
    width: 220px;
    flex-wrap: wrap;
    //background: pink;
    justify-content: center;
    margin-top: 10px;

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      margin-top: 15px;
      text-align: center;
      width: 245px;
      // height: 18px;
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
    }
  }

  .list {
    width: 220px;
    display: flex;
    margin-top: 24px;
    justify-content: space-around;

    .listItem {
      width: 50px;
      height: 50px;
      text-align: center;
      align-items: center;
      margin-top: -5px;

      .text {
        text-align: center;
        //width: 48px;
        //height: 11px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .time {
        //background: pink;
        //width: 44px;
        //height: 17px;
        font-size: 20px;
        font-family: Dancing Script;
        font-weight: bold;
        color: #ff7d14;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
